import { useState } from 'react'
import UtilityService from '../services/UtillityServices/UtilityService';
import AuthService from '../services/AuthService/AuthService';
import {useNavigate} from 'react-router'
import { useDispatch } from 'react-redux';
import { setLoggedUser } from '../store/actions/user';
import { handleError } from '../model/handleError';
import { alertService } from '../services/AlertService';

const useAuth = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [loadingState, setLoadingState] = useState({
      isLoadingLogin: false,
      isLoadingRegister: false,
    });
    const [loadingStateForm, setLoadingStateForm] = useState({//NEW
      isLoadingRequestForm: false,//NEW
    });
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const register = async (obj) => {
        setLoadingState({ ...loadingState, isLoadingRegister: true });
        try {
            const response = await AuthService.register(obj);
            return response;
        } catch (err) {
          handleError(err, {
            RESOURCE_ALREADY_EXISTS: "L'utente con l'email specificata è già esistente"
         });
        } finally {
          setLoadingState({ ...loadingState, isLoadingRegister: false });
        }
    };

    const requestForm = async (obj) => {//NEW
      setLoadingStateForm({ ...loadingStateForm, isLoadingRequestForm: true });
      try {
          const response = await AuthService.requestForm(obj);//
          return response;
      } catch (err) {
        handleError(err, {
          RESOURCE_ALREADY_EXISTS: "L'utente con l'email specificata è già esistente"
       });
      } finally {
        setLoadingStateForm({ ...loadingStateForm, isLoadingRequestForm: false });
      }
  };

    const login = async (obj) => {
      setLoadingState({ ...loadingState, isLoadingLogin: true });
      try {
          const response = await AuthService.login(obj);
          if(response?.success){
            response.username = obj.username;
            return response;
          }
        } catch (err) {
          handleError(err, {
              INVALID_CREDENTIAL: "Credenziali non valide",
              USER_NOT_ACTIVE: "Prima di accedere conferma il link presente nell'email"
           });
        } finally {
          setLoadingState({ ...loadingState, isLoadingLogin: false });
        }
  };

    const completeProfile = async (obj, authResponse) => {
      setIsLoading(true); 
      try {
          if(authResponse) {
            const response = await AuthService.completeProfile(obj, authResponse);
            if(response) {
              authResponse = '';
              return response;
            }
        }
          
      } catch (err) {
          handleError(err, {
            NOT_FOUND: "L'utente con l'email speficiata non è stato trovato"
          })
      } finally {
          setIsLoading(false)
      }
    };

    const resendEmailRegister = async (email) => {
      setIsLoading(true); 
      try {
          const response = await AuthService.resendEmailRegister(email);
          alertService.success(`Email inviata con successo`, {autoClose: true});
          return response;
      } catch (err) {
        handleError(err, {
          NOT_FOUND: "L'utente con l'email speficiata non è stato trovato"
        })
      } finally {
         setIsLoading(false)
      }
    }

    const resetPassword = async (data, token) => {
      setIsLoading(true); 
      try {
          const response = await AuthService.resetPassword(data, token);
          // if(response?.error === "Errore durante cambio password: Campo new_password e old_password sono uguali") {
          //   UtilityService.showAlert("Hai inserito la tua vecchia password, inserisci una nuova password", "warning", 5000)
          //   return;
          // }
          if(response) {
            return response;
          }
      } catch (err) {
        handleError(err)
        // if(err.error?.includes("La password deve contenere almeno 8 caratteri")) {
        //   UtilityService.showAlert("La password deve contenere almeno 8 caratteri, tra cui almeno 1 lettera maiuscola, 1 minuscola, 1 carattere speciale e 1 numero", "warning", 8000)
        //   return;
        // }
        // UtilityService.showAlert("Si è verificato un errore", "danger")
      } finally {
         setIsLoading(false)
      }
    }

    const forgotPassword = async (data) => {
      setIsLoading(true); 
      try {
          const response = await AuthService.forgotPassword(data);
          if(response) {
            alertService.success(`Una nuova password è stata inviata a ${data.username}`, {autoClose: true});
            return response;
          }
      } catch (err) {
          handleError(err, {
            NOT_FOUND: "L'utente con l'email specificata non esiste."
          })
      } finally {
          setIsLoading(false)
      }
    }

    const getUserByUsername = async (username) => {
      setIsLoading(true); 
      try {
          const response = await AuthService.getUserByUsername(username);
          return response;
      } catch (err) {
          handleError(err)
      } finally {
          setIsLoading(false)
      }
    }
    const getUserInfoLoggedIn = async () => {
      setIsLoading(true); 
      try {
          const response = await AuthService.getUserInfoLoggedIn();
          return response;
      } catch (err) {
         handleError(err);
      } finally {
          setIsLoading(false)
      }
    }

    const logout = () => {
      dispatch(setLoggedUser(null)); 
      navigate("/accedi");
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
    }
 
  return {
    isLoading,
    register,
    requestForm,
    login,
    completeProfile,
    forgotPassword,
    resendEmailRegister,
    getUserByUsername,
    getUserInfoLoggedIn,
    resetPassword,
    loadingState,
    loadingStateForm
  };      
}

export default useAuth;